/**
 * 주문 엑셀 다운로드 요청(order-service feat/order-export-async, OrderExportJobDtos).
 * 요청 → 백그라운드 생성 → 내역에서 파일별로 받는다(고도몰 ExcelRequest.php 방식).
 */
export type OrderExportJobStatus = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'EXPIRED';

export interface OrderExportFile {
  fileNo: number;
  fileName: string;
  rows: number;
  sizeBytes: number;
}

export interface OrderExportJob {
  exportJobId: string;
  status: OrderExportJobStatus | string;
  progressPercent: number;
  totalOrders: number | null;
  processedOrders: number;
  totalRows: number;
  rowsPerFile: number;
  /** YYYY-MM-DD */
  dateFrom: string | null;
  dateTo: string | null;
  files: OrderExportFile[];
  errorMessage: string | null;
  requestedBy: string | null;
  requestedAt: string | null;
  startedAt: string | null;
  completedAt: string | null;
  /** 비밀번호를 건 엑셀(열 때 비밀번호 필요). BE 반영 전 응답엔 없음. */
  passwordProtected?: boolean | null;
  /** 완료 후 7일 보관 기한. 지나면 EXPIRED. */
  expiresAt: string | null;
}

/** POST 본문 — 키는 동기 export 쿼리 파라미터와 같은 이름. 배열 키는 반복값을 그대로 담는다. */
export type OrderExportCriteria = Record<string, string | number | string[]>;

/** 파일당 행 수 선택지(BE 허용 1,000~100,000, 기본 50,000). */
export const ROWS_PER_FILE_OPTIONS = [10_000, 30_000, 50_000] as const;
export const DEFAULT_ROWS_PER_FILE = 50_000;
